var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as _ from "lodash";
import { DiagramBase } from '../basics/DiagramBase';
import { prepareDiagramData2D } from "../basics/Statistics";
import { setOrDef } from "../Helpers";
var Radar = /** @class */ (function (_super) {
    __extends(Radar, _super);
    function Radar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.calcData = function (props) {
            console.log("calcData");
            var d = props.diagram;
            prepareDiagramData2D(props.diagram, {
                type: "radar"
            }).then(function (d) {
                _this.setState({
                    data: d.data.series.map(function (s) {
                        var data = s.data, rest = __rest(s, ["data"]);
                        return __assign({ value: _.map(data, function (dx) { return dx.value; }) }, rest);
                    }), keys: d.keys
                });
                if (_this.props.onFieldsLoaded)
                    _this.props.onFieldsLoaded(d.fields);
            });
        };
        _this.getOption = function () {
            var d = _this.props.diagram;
            if (!_this.state.data)
                return undefined;
            var option = {
                backgroundColor: d.backgroundColor,
                color: d.colors ? d.colors.colors : undefined,
                tooltip: {
                    show: true,
                },
                toolbox: {
                    bottom: 0,
                    left: 2,
                    showTitle: false,
                    orient: 'vertical',
                    feature: {
                        saveAsImage: {
                            show: setOrDef(d.legend, function (x) { return x.showDownload; }, false),
                        }
                    }
                },
                legend: d.legend && d.legend.show ? {
                    show: true,
                    orient: setOrDef(d.legend, function (x) { return x.direction; }, 'vertical'),
                    align: setOrDef(d.legend, function (x) { return x.itemAlign; }, 'auto'),
                    left: setOrDef(d.legend, function (x) { return x.horizontalAlignment; }, 'right'),
                    top: setOrDef(d.legend, function (x) { return x.verticalAlignment; }, 'top'),
                    padding: [
                        setOrDef(d.legend.padding, function (x) { return x.top; }, 0),
                        setOrDef(d.legend.padding, function (x) { return x.right; }, 0),
                        setOrDef(d.legend.padding, function (x) { return x.bottom; }, 0),
                        setOrDef(d.legend.padding, function (x) { return x.left; }, 0),
                    ],
                    textStyle: { color: setOrDef(d.legend, function (x) { return x.fontColor; }, '#000000') }
                } : { show: false },
                radar: {
                    shape: 'circle',
                    axisLine: {
                        show: true,
                    },
                    name: {
                        textStyle: {
                            color: setOrDef(d, function (x) { return x.fontColor; }, '#000'),
                            fontSize: setOrDef(d, function (x) { return x.fontSize; }, 16)
                        }
                    },
                    indicator: _this.state.keys && _this.state.keys.length > 0 ? _this.state.keys[0].names.map(function (v) { return ({ name: v }); }) : []
                },
                series: {
                    symbolKeepAspect: true,
                    type: 'radar',
                    symbol: setOrDef(d, function (x) { return x.symbolType; }, 'circle'),
                    symbolSize: setOrDef(d, function (x) { return x.symbolSize; }, 8),
                    areaStyle: d.area && d.area.show ? {
                        opacity: setOrDef(d.area, function (x) { return x.opacity; }, 0) / 100,
                    } : undefined,
                    data: _this.state.data
                }
            };
            return option;
        };
        _this.findDataElement = function (path) {
            return undefined;
        };
        return _this;
    }
    return Radar;
}(DiagramBase));
export default Radar;
//# sourceMappingURL=Radar.js.map